export default "__VITE_ASSET__cy1NU$vl__"